import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CrudWithSteps from '../../../../../components/CrudWithSteps/CrudWithSteps';
import AssignmentLateRoundedIcon from '../../../../../components/Icons/AssignmentLateRoundedIcon';
import AssignmentTurnedInRoundedIcon from '../../../../../components/Icons/AssignmentTurnedInRoundedIcon';
import CloudDownloadIcon from '../../../../../components/Icons/CloudDownloadIcon';
import CloudIcon from '../../../../../components/Icons/CloudIcon';
import DescriptionRoundedIcon from '../../../../../components/Icons/DescriptionRoundedIcon';
import { UnauthorizedScreen } from '../../../../../components/UnauthorizedScreen';
import {
  allContratoEntePublicoEditEtapas,
  CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
  CONTRATO_EDIT_ETAPA_ARQUIVOS,
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS,
  CONTRATO_EDIT_ETAPA_VALIDACAO,
} from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_STATUS_APROVADO,
  CONTRATO_STATUS_DESATIVADO,
  CONTRATO_STATUS_EM_ANALISE,
  CONTRATO_STATUS_EM_EDICAO,
  CONTRATO_STATUS_NEGADO,
  CONTRATO_STATUS_AGUARDANDO_ASSINATURA,
  CONTRATO_STATUS_NAO_INICIADO,
  CONTRATO_STATUS_VIGENTE,
  CONTRATO_STATUS_ENCERRADO,
  CONTRATO_STATUS_AGUARDANDO_EXTRATO,
} from '../../../../../library/ContratoStatus';
import { CONTRATO_TIPO_ENTE_PUBLICO_NAME } from '../../../../../library/ContratoTipos';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_DISTRATO,
  CONTRATO_VERSAO_DISTRATO_NAME,
} from '../../../../../library/ContratoVersoes';
import {
  changeContratoEntePublicoEditingValue,
  clearContratoEntePublicoEditing,
  loadContratoEntePublico,
  loadHistoricoContratoEntePublicoAnaliseOperacional,
  loadContratoEntePublicoArquivos,
} from '../../../../../store/modules/ContratosEntePublicoActions';
import AnaliseOperacional from './AnaliseOperacional';
import Arquivos from './Arquivos';
import styles from './ContratoEntePublicoEdit.scss';
import DadosContrato from './DadosContrato';
import DadosCooperativa from './DadosCooperativa';
import DownloadChecklists from './DownloadChecklists';
import Validacao from './Validacao';
import { isAuthorizedRequest } from '../../../../../utils/httpResponseHandlers';
import SnackbarUtils from 'utils/SnackbarUtils';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  loading: true,

  authorizedRequest: true,

  stepIndex: 0,
};

class ContratoEntePublicoEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      loading: props.utils.editing() ? true : false,
    };
  }

  getLoadMessageError = () => {
    switch (this.props.utils.getVersaoNumberByProps()) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues.erroCarregarAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues.erroCarregarDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues.erroCarregarContrato;
    }
  };

  loadContratoArquivos = () => {
    this.props.loadContratoEntePublicoArquivos(
      this.props.utils.getIdContratoByProps(),
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadContratoArquivos,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadHistoricoAnaliseOperacional = () => {
    this.props.loadHistoricoContratoEntePublicoAnaliseOperacional(
      this.props.utils.getIdOfVersao(),
      this.props.utils.getVersaoNumberByProps(),
      null,
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadHistoricoAnaliseOperacional,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  loadContrato = () => {
    let id = null;
    let versao = null;
    switch (this.props.utils.getVersaoByProps()) {
      case CONTRATO_VERSAO_ADITIVO_NAME:
        id = this.props.utils.editing()
          ? this.props.utils.getIdAditivoByProps()
          : this.props.utils.getIdContratoByProps();
        versao = this.props.utils.editing()
          ? CONTRATO_VERSAO_ADITIVO
          : CONTRATO_VERSAO_CONTRATO;
        break;
      case CONTRATO_VERSAO_DISTRATO_NAME:
        id = this.props.utils.editing()
          ? this.props.utils.getIdDistratoByProps()
          : this.props.utils.getIdContratoByProps();
        versao = this.props.utils.editing()
          ? CONTRATO_VERSAO_DISTRATO
          : CONTRATO_VERSAO_CONTRATO;
        break;
      default:
        id = this.props.utils.getIdContratoByProps();
        versao = CONTRATO_VERSAO_CONTRATO;
        break;
    }
    this.setState({ loading: true });
    this.props.loadContratoEntePublico(
      id,
      versao,
      () => {
        this.props.changeContratoEntePublicoEditingValue(
          'versaoContrato',
          this.props.utils.getVersaoNumberByProps()
        );
        if (
          !this.props.utils.editing() &&
          this.props.utils.getIdContratoByProps()
        ) {
          this.props.changeContratoEntePublicoEditingValue(
            'flgStatus',
            CONTRATO_STATUS_EM_EDICAO
          );
        }
        switch (this.props.utils.getEtapaByProps()) {
          case CONTRATO_EDIT_ETAPA_VALIDACAO:
            this.loadHistoricoAnaliseOperacional();
            this.setState({ loading: false });
            break;
          case CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL:
            this.loadHistoricoAnaliseOperacional();
            this.setState({ loading: false });
            break;
          case CONTRATO_EDIT_ETAPA_ARQUIVOS:
            this.loadContratoArquivos();
            this.setState({ loading: false });
            break;
          default:
            this.setState({ loading: false });
            break;
        }
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          SnackbarUtils.enqueueSnackbar({
            message: error.response.statusText || this.getLoadMessageError(),
            options: {
              variant: 'error',
            },
          });
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false, authorizedRequest: false });
        }
      }
    );
  };

  refreshStep = () => {
    this.loadContrato();
  };

  componentDidMount() {
    if (this.props.utils.editing()) {
      this.loadContrato();
    } else {
      if (
        this.props.utils.getVersaoNumberByProps() !== CONTRATO_VERSAO_CONTRATO
      ) {
        this.loadContrato();
      }
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.match.url !== this.props.match.url) {
      if (this.props.utils.editing()) {
        this.loadContrato();
      } else {
        if (
          this.props.utils.getVersaoNumberByProps() !== CONTRATO_VERSAO_CONTRATO
        ) {
          this.loadContrato();
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.clearContratoEntePublicoEditing();
  }

  etapaDownloadChecklistsIsEnabled = () => {
    return true;
  };

  etapaDownloadChecklistsColors = () => {
    return {
      color: styles.sicrediGreen,
      contrastColor: styles.sicrediGreenContrast,
    };
  };

  toEtapaDownloadChecklists = () => {
    const enabledOptions = {
      newContrato: true,
      newAditivo: true,
      newDistrato: true,
      editContrato: true,
      editAditivo: true,
      editDistrato: true,
    };
    this.props.utils.toStep(
      CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS,
      enabledOptions
    );
  };

  getContentsEtapaDownloadChecklists = (toSteps) => {
    const editing = this.props.utils.editing();
    if (!this.etapaDownloadChecklistsIsEnabled()) {
      return [];
    }
    return [
      {
        component: DownloadChecklists,
        props: {
          toEtapaDados: this.toEtapaDados,
          toSteps,
          utils: this.props.utils,
          editing,
          loading: this.state.loading,
        },
      },
    ];
  };

  etapaDadosIsEnabled = () => {
    return true;
  };

  etapaDadosColors = () => {
    if (
      this.props.contratosEntePublico.contratoEditing.flgStatus ===
      CONTRATO_STATUS_DESATIVADO
    ) {
      return {
        color: styles.disabled,
        contrastColor: '#000',
      };
    }
    return {
      color: this.props.utils.editing()
        ? styles.sicrediGreen
        : styles.pufvYellow,
      contrastColor: this.props.utils.editing()
        ? styles.sicrediGreenContrast
        : styles.pufvYellowContrast,
    };
  };

  toEtapaDados = () => {
    const enabledOptions = {
      newContrato: true,
      newAditivo: true,
      newDistrato: true,
      editContrato: true,
      editAditivo: true,
      editDistrato: true,
    };
    this.props.utils.toStep(CONTRATO_EDIT_ETAPA_DADOS, enabledOptions);
  };

  getContentsEtapaDados = (toSteps) => {
    const editing = this.props.utils.editing();

    const totalBullets = 2;
    let contents = [
      {
        component: DadosCooperativa,
        props: {
          toSteps,
          versaoContrato: this.props.utils.getVersaoNumberByProps(),
          totalBullets: totalBullets,
          bulletsIndex: 0,
          editing,
          loading: this.state.loading,
        },
      },
      {
        component: DadosContrato,
        props: {
          versaoContrato: this.props.utils.getVersaoNumberByProps(),
          totalBullets: totalBullets,
          bulletsIndex: 1,
          editing,
          loading: this.state.loading,
        },
      },
    ];

    return contents;
  };

  etapaValidacaoIsEnabled = () => {
    if (this.props.utils.editing()) {
      return true;
    }
    return false;
  };

  etapaValidacaoColors = () => {
    if (!this.props.utils.editing()) {
      return {
        color: styles.pufvYellow,
        contrastColor: styles.pufvYellowContrast,
      };
    }
    switch (this.props.contratosEntePublico.contratoEditing.flgStatus) {
      case CONTRATO_STATUS_EM_EDICAO:
      case CONTRATO_STATUS_APROVADO:
        return {
          color: styles.pufvYellow,
          contrastColor: styles.pufvYellowContrast,
        };
      case CONTRATO_STATUS_NEGADO:
        return {
          color: styles.error,
          contrastColor: styles.errorContrast,
        };
      case CONTRATO_STATUS_EM_ANALISE:
        return {
          color: styles.warning,
          contrastColor: styles.warningContrast,
        };
      case CONTRATO_STATUS_DESATIVADO:
        return {
          color: styles.disabled,
          contrastColor: '#000',
        };
      default:
        return {
          color: styles.sicrediGreen,
          contrastColor: styles.sicrediGreenContrast,
        };
    }
  };

  toEtapaValidacao = () => {
    const enabledOptions = {
      editContrato: true,
      editAditivo: true,
      editDistrato: true,
    };
    this.props.utils.toStep(CONTRATO_EDIT_ETAPA_VALIDACAO, enabledOptions);
  };

  getContentsEtapaValidacao = (toSteps) => {
    const editing = this.props.utils.editing();
    if (!this.etapaValidacaoIsEnabled()) {
      return [];
    }
    return [
      {
        component: Validacao,
        props: {
          utils: this.props.utils,
          toSteps,
          editing,
          loading: this.state.loading,
          refreshStep: this.refreshStep,
        },
      },
    ];
  };

  etapaAnaliseOperacionalIsEnabled = () => {
    return (
      this.props.contratosEntePublico.contratoEditing.ativo &&
      this.props.utils.editing() &&
      this.props.contratosEntePublico.contratoEditing.flgStatus === CONTRATO_STATUS_EM_ANALISE &&
      this.props.auth.userPermissions.contratos.entePublico.analiseOperacional.edit
    );
  };

  etapaAnaliseOperacionalColors = () => {
    if (!this.props.utils.editing()) {
      return {
        color: styles.disabled,
        contrastColor: '#000',
      };
    }
    switch (this.props.contratosEntePublico.contratoEditing.flgStatus) {
      case CONTRATO_STATUS_EM_ANALISE:
        return {
          color: styles.pufvYellow,
          contrastColor: styles.pufvYellowContrast,
        };
      default:
        return {
          color: styles.disabled,
          contrastColor: '#000',
        };
    }
  };

  toEtapaAnaliseOperacional = () => {
    const enabledOptions = {
      editContrato: true,
      editAditivo: true,
      editDistrato: true,
    };
    this.props.utils.toStep(
      CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL,
      enabledOptions
    );
  };

  getContentsEtapaAnaliseOperacional = (toSteps) => {
    const editing = this.props.utils.editing();
    if (!this.etapaAnaliseOperacionalIsEnabled()) {
      return [];
    }
    return [
      {
        component: AnaliseOperacional,
        props: {
          etapaValidacaoIsEnabled: this.etapaValidacaoIsEnabled,
          toEtapaValidacao: this.toEtapaValidacao,
          utils: this.props.utils,
          toSteps,
          editing,
          loading: this.state.loading,
          refreshStep: this.refreshStep,
        },
      },
    ];
  };

  etapaArquivosIsEnabled = () => {
    if (this.props.utils.editing()) {
      if (
        this.props.utils.getVersaoByProps() === CONTRATO_VERSAO_CONTRATO_NAME
      ) {
        switch (this.props.contratosEntePublico.contratoEditing.flgStatus) {
          case CONTRATO_STATUS_AGUARDANDO_ASSINATURA:
          case CONTRATO_STATUS_NAO_INICIADO:
          case CONTRATO_STATUS_VIGENTE:
          case CONTRATO_STATUS_ENCERRADO:
          case CONTRATO_STATUS_DESATIVADO:
          case CONTRATO_STATUS_AGUARDANDO_EXTRATO:
            return true;
          default:
            return false;
        }
      }
      return true;
    } else {
      if (
        this.props.utils.getVersaoByProps() === CONTRATO_VERSAO_CONTRATO_NAME
      ) {
        return false;
      }
      return true;
    }
  };

  etapaArquivosColors = () => {
    return {
      color: this.etapaArquivosIsEnabled()
        ? styles.sicrediGreen
        : styles.disabled,
      contrastColor: this.etapaArquivosIsEnabled()
        ? styles.sicrediGreenContrast
        : '#000',
    };
  };

  toEtapaArquivos = () => {
    const enabledOptions = {
      newAditivo: true,
      newDistrato: true,
      editContrato: true,
      editAditivo: true,
      editDistrato: true,
    };
    this.props.utils.toStep(CONTRATO_EDIT_ETAPA_ARQUIVOS, enabledOptions);
  };

  getContentsEtapaArquivos = (toSteps) => {
    const editing = this.props.utils.editing();
    if (!this.etapaArquivosIsEnabled()) {
      return [];
    }
    return [
      {
        component: Arquivos,
        props: {
          utils: this.props.utils,
          toSteps,
          editing,
          refreshStep: this.refreshStep,
          loading: this.state.loading,
        },
      },
    ];
  };

  getSteps = () => {
    let steps = [
      {
        name: this.props.languageValues.contratoNavbarStepNames[
          CONTRATO_TIPO_ENTE_PUBLICO_NAME
        ][CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS],
        ...this.etapaDownloadChecklistsColors(),
        icon: <CloudDownloadIcon />,
        onClick: this.toEtapaDownloadChecklists,
        selected:
          this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[0]
            ? true
            : false,
        disabled: false,
      },
      {
        name: this.props.languageValues.contratoNavbarStepNames[
          CONTRATO_TIPO_ENTE_PUBLICO_NAME
        ][CONTRATO_EDIT_ETAPA_DADOS],
        ...this.etapaDadosColors(),
        icon: <DescriptionRoundedIcon />,
        onClick: this.toEtapaDados,
        selected:
          this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[1]
            ? true
            : false,
        disabled:
          this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[1]
            ? true
            : false,
      },
      {
        name: this.props.languageValues.contratoNavbarStepNames[
          CONTRATO_TIPO_ENTE_PUBLICO_NAME
        ][CONTRATO_EDIT_ETAPA_VALIDACAO],
        ...this.etapaValidacaoColors(),
        icon: <AssignmentTurnedInRoundedIcon />,
        onClick: this.toEtapaValidacao,
        selected:
          this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[2]
            ? true
            : false,
        disabled:
          !this.etapaValidacaoIsEnabled() ||
          this.props.utils.getEtapaByProps() ===
            allContratoEntePublicoEditEtapas[2]
            ? true
            : false,
      },
    ];
    if (this.etapaAnaliseOperacionalIsEnabled()) {
      steps.push({
        name: this.props.languageValues.contratoNavbarStepNames[
          CONTRATO_TIPO_ENTE_PUBLICO_NAME
        ][CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL],
        ...this.etapaAnaliseOperacionalColors(),
        icon: <AssignmentLateRoundedIcon />,
        onClick: this.toEtapaAnaliseOperacional,
        selected:
          this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[3]
            ? true
            : false,
        disabled:
          this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[3]
            ? true
            : false,
      });
    }
    steps.push({
      name: this.props.languageValues.contratoNavbarStepNames[
        CONTRATO_TIPO_ENTE_PUBLICO_NAME
      ][CONTRATO_EDIT_ETAPA_ARQUIVOS],
      ...this.etapaArquivosColors(),
      icon: <CloudIcon />,
      onClick: this.toEtapaArquivos,
      selected:
        this.props.utils.getEtapaByProps() ===
        allContratoEntePublicoEditEtapas[4]
          ? true
          : false,
      disabled:
        !this.etapaArquivosIsEnabled() ||
        this.props.utils.getEtapaByProps() ===
          allContratoEntePublicoEditEtapas[4]
          ? true
          : false,
    });
    return steps;
  };

  getContents = () => {
    const toSteps = {
      toEtapaDownloadChecklists: this.toEtapaDownloadChecklists,
      toEtapaDados: this.toEtapaDados,
      toEtapaValidacao: this.toEtapaValidacao,
      toEtapaAnaliseOperacional: this.toEtapaAnaliseOperacional,
      toEtapaArquivos: this.toEtapaArquivos,
    };
    switch (this.props.utils.getEtapaByProps()) {
      case CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS:
        return this.getContentsEtapaDownloadChecklists(toSteps);
      case CONTRATO_EDIT_ETAPA_DADOS:
        return this.getContentsEtapaDados(toSteps);
      case CONTRATO_EDIT_ETAPA_VALIDACAO:
        return this.getContentsEtapaValidacao(toSteps);
      case CONTRATO_EDIT_ETAPA_ANALISE_OPERACIONAL:
        return this.getContentsEtapaAnaliseOperacional(toSteps);
      case CONTRATO_EDIT_ETAPA_ARQUIVOS:
      default:
        return this.getContentsEtapaArquivos(toSteps);
    }
  };

  setStepIndex = (index) => {
    this.setState({
      stepIndex: index,
    });
  };

  hasPermissions = () => {
    const editing = this.props.utils.editing();
    if (this.state.loading) {
      return true;
    }
    if (editing) {
      if (
        this.props.auth.userPermissions.contratos.entePublico
          .downloadChecklist ||
        this.props.auth.userPermissions.contratos.entePublico.view ||
        this.props.auth.userPermissions.contratos.entePublico.edit ||
        this.props.auth.userPermissions.contratos.entePublico.analiseOperacional
          .edit
      ) {
        if (
          this.state.loading === false &&
          this.props.contratosEntePublico.contratoEditing.idContrato &&
          this.props.auth.userPermissions.contratos.entePublico.allStatus.indexOf(
            this.props.contratosEntePublico.contratoEditing.flgStatus
          ) > -1
        ) {
          return true;
        }
      }
    } else {
      if (this.props.auth.userPermissions.contratos.entePublico.register) {
        return true;
      }
    }
    return false;
  };

  routeParamsIsValid = () => {
    const versao = this.props.utils.getVersaoByProps();
    const etapa = this.props.utils.getEtapaByProps();
    const editing = this.props.utils.editing();
    if (editing) {
      switch (versao) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
          return this.props.utils.getIdContratoByProps() &&
            this.props.utils.getIdAditivoByProps() &&
            etapa
            ? true
            : false;
        case CONTRATO_VERSAO_DISTRATO_NAME:
          return this.props.utils.getIdContratoByProps() &&
            this.props.utils.getIdDistratoByProps() &&
            etapa
            ? true
            : false;
        default:
          return this.props.utils.getIdContratoByProps() && etapa
            ? true
            : false;
      }
    } else {
      switch (versao) {
        case CONTRATO_VERSAO_ADITIVO_NAME:
        case CONTRATO_VERSAO_DISTRATO_NAME:
          return this.props.utils.getIdContratoByProps() && etapa
            ? true
            : false;
        default:
          return etapa ? true : false;
      }
    }
  };

  render() {
    const steps = this.getSteps();
    const contents = this.getContents();
    return this.hasPermissions() &&
      this.routeParamsIsValid() &&
      this.state.authorizedRequest &&
      contents.length > 0 ? (
      <CrudWithSteps
        className={rootClassName}
        steps={steps}
        contents={contents}
        contentIndex={this.state.stepIndex}
        setContentIndex={this.setStepIndex}
      />
    ) : this.state.loading ? null : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoEntePublicoEditingValue,
      loadContratoEntePublico,
      loadHistoricoContratoEntePublicoAnaliseOperacional,
      loadContratoEntePublicoArquivos,
      clearContratoEntePublicoEditing,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ContratoEntePublicoEdit));
